module.exports = __webpack_public_path__ + "static/media/Breeze.0f24f6bd.png";